import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { LANGUAGES } from "@/i18n";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = LANGUAGES.find((l) => l.code === i18n.language) || LANGUAGES[0];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        data-testid="language-switcher"
        className="flex items-center gap-1.5 text-[10px] tracking-[0.25em] uppercase text-[#D1C7C9] hover:text-[#D4AF37] transition-colors px-2 py-1 rounded border border-[#3D1A21] hover:border-[#D4AF37]/40"
        aria-label="Change language"
      >
        <Globe size={11} />
        <span>{current.short}</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-44 glass-card-strong border border-[#D4AF37]/30 rounded-lg overflow-hidden z-50" data-testid="language-dropdown">
          {LANGUAGES.map((l) => {
            const active = l.code === current.code;
            return (
              <button
                key={l.code}
                onClick={() => { i18n.changeLanguage(l.code); setOpen(false); }}
                data-testid={`lang-${l.code}`}
                className={`w-full flex items-center justify-between px-3 py-2.5 text-sm transition-colors ${active ? "bg-[#E69138]/15 text-[#E69138]" : "text-[#D1C7C9] hover:bg-[#3D1A21]"}`}
              >
                <span>{l.label}</span>
                {active && <Check size={14} />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
